import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-all duration-300 transform hover:scale-110 group"
      aria-label="Toggle theme"
    >
      {/* Background circle that moves */}
      <div className={`absolute inset-0 w-full h-full bg-[#3A7CA5] rounded-full transform transition-all duration-500 ${isDark ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}></div>
      
      {/* Sun Icon */}
      <Sun 
        className={`w-5 h-5 absolute top-2 left-2 text-[#E6B566] transform transition-all duration-500 ${
          isDark ? 'rotate-180 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'
        }`} 
      />
      
      {/* Moon Icon */}
      <Moon 
        className={`w-5 h-5 absolute top-2 left-2 text-white transform transition-all duration-500 ${
          isDark ? 'rotate-0 scale-100 opacity-100' : 'rotate-180 scale-0 opacity-0'
        }`} 
      />
      
      {/* Invisible spacer to maintain button size */}
      <div className="w-5 h-5 opacity-0"></div>
      
      {/* Floating particles effect */}
      <div className="absolute -inset-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute top-0 left-0 w-1 h-1 bg-[#E6B566] rounded-full animate-ping"></div>
        <div className="absolute top-1 right-0 w-1 h-1 bg-[#A9D6E5] rounded-full animate-ping animation-delay-150"></div>
        <div className="absolute bottom-0 right-1 w-1 h-1 bg-[#3A7CA5] rounded-full animate-ping animation-delay-300"></div>
      </div>
    </button>
  );
};

export default ThemeToggle;